'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // const colors = ['white', 'black', 'light', 'dark', 'primary', 'info', 'link', 'success', 'warning', 'danger', 'black-bis', 'black-ter', 'grey-darker', 'grey-dark', 'grey', 'grey-light', 'grey-lighter', 'white-ter', 'white-bis'];


exports.default = {
  propTypes: {
    textColor: _propTypes2.default.string,
    backgroundColor: _propTypes2.default.string
  },
  defaultProps: {
    textColor: undefined,
    backgroundColor: undefined
  },
  classnames: function classnames(props) {
    var _classnames2;

    return (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, 'has-text-' + props.textColor, props.textColor), _defineProperty(_classnames2, 'has-background-' + props.backgroundColor, props.backgroundColor), _classnames2));
  },
  clean: function clean(_ref) {
    var textColor = _ref.textColor,
        backgroundColor = _ref.backgroundColor,
        props = _objectWithoutProperties(_ref, ['textColor', 'backgroundColor']);

    return props;
  }
};